import React from 'react';
import styled from 'styled-components';
import Icon from 'kingpin/atoms/Icon';

const OnboardingTopBarWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  width: 100%;
  height: 52px;
  border-bottom: 1px solid var(--color-border-secondary);
`;

const OnboardingTopBar = () => {
  return (
    <OnboardingTopBarWrapper>
      <Icon icon={'branding-large'} width={98} height={22} />
    </OnboardingTopBarWrapper>
  );
};

export default OnboardingTopBar;
